import { canonicalI18n, pathLangFrom } from "./lang";

const GREEK_TO_LATIN_MAP = {
  α: "a", β: "v", γ: "g", δ: "d", ε: "e", ζ: "z", η: "i", θ: "th",
  ι: "i", κ: "k", λ: "l", μ: "m", ν: "n", ξ: "x", ο: "o", π: "p",
  ρ: "r", σ: "s", ς: "s", τ: "t", υ: "y", φ: "f", χ: "ch", ψ: "ps",
  ω: "o",
};

export const slugify = (value = "") => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  const normalized = raw.normalize("NFKD").replace(/[\u0300-\u036f]/g, "");
  const withDigraphs = normalized
    .replace(/ΟΥ/g, "OU")
    .replace(/Ου/g, "Ou")
    .replace(/ου/g, "ou");
  const transliterated = withDigraphs.replace(/[Α-Ωα-ω]/g, (char) => {
    const lower = char.toLowerCase();
    return GREEK_TO_LATIN_MAP[lower] || lower;
  });
  return transliterated
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

export const getLocalizedField = (recipe, base, locale) => {
  if (!recipe) return "";
  const canon = canonicalI18n(locale || "en");
  const primary = canon.split("-")[0];
  const candidates = [];

  if (canon === "en-US") candidates.push(`${base}_en_us`);
  if (canon === "en-GB") candidates.push(`${base}_en_gb`);
  if (primary === "en") candidates.push(`${base}_en`);
  if (primary === "el") candidates.push(`${base}_el`);

  candidates.push(base);

  for (const key of candidates) {
    const val = recipe?.[key];
    if (val !== undefined && val !== null && String(val).trim() !== "") return val;
  }
  return "";
};

export const buildRecipeSlug = (recipe, locale) => {
  if (!recipe?.id) return "";
  const name = getLocalizedField(recipe, "name", locale);
  const base = slugify(name) || "recipe";
  return `${base}-${recipe.id}`;
};

export const buildRecipePath = (recipe, locale) => {
  if (!recipe?.id) return "";
  const langPath = pathLangFrom(locale || "en");
  const slug = buildRecipeSlug(recipe, locale);
  return `/${langPath}/recipe/${recipe.id}/${slug}`;
};

export const buildRecipePathFromParts = ({ id, name, locale }) => {
  if (!id) return "";
  const langPath = pathLangFrom(locale || "en");
  const slug = `${slugify(name || "") || "recipe"}-${id}`;
  return `/${langPath}/recipe/${id}/${slug}`;
};
